import React, { Component } from "react";
import PropTypes from "prop-types";
import RadioGroup from "../../../../components/common/radioGroup/RadioGroup";
import { Field } from "redux-form";
import styles from "./CheckboxRadio.scss";
import _ from "lodash";

import prettyCheckbox from "../../../../assets/styles/pretty-checkbox/pretty-checkbox.scss";
import blueCheck from "../../../../assets/images/checked-blue-x2.png";
import classnames from "classnames";

class CheckboxRadio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showRadios: props.showRadios || false,
      selected: null
    };

    this.onReturn(props);

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.onReturn(this.props);
  }

  onReturn(props) {
    if (props.onCheck && props.input.value.have) {
      props.onCheck(true);
      const value = props.input.value;
      this.state.selected = value;
      this.state.showRadios = value;
      props.input.onChange(value);
    }
  }

  // Fired when check or uncheck the checkbox
  onChange(event) {
    const checked = event.target.checked;
    this.props.input.onChange(checked);
    if (this.props.onCheck) {
      this.props.onCheck(checked);
    }
  }

  // Fired when change the option of the radiogroup
  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      let value = nextProps.input.value;
      if (!_.isNull(value) && !_.isUndefined(value) && value !== "") {
        this.setState(
          { selected: value, showRadios: value },
          this.props.input.onChange(value)
        );
      }
    }
  }

  render() {
    const { input, formGroupClassName, text, eleId, name } = this.props;
    return (
      <div
        className={classnames(styles.checkboxRadio, {
          [styles.active]: this.state.showRadios,
          [styles.notActive]: !this.state.showRadios
        })}
      >
        <div
          className={classnames(
            prettyCheckbox.pretty,
            prettyCheckbox["p-image"],
            prettyCheckbox["p-curve"],
            prettyCheckbox["p-smooth"],
            formGroupClassName,
            styles.checkbox
          )}
        >
          <input
            ref={ref => (this._input = ref)}
            type="checkbox"
            checked={
              this.props.controlCheck ? this.props.isChecked : input.value
            }
            onChange={this.onChange}
            disabled={this.props.disabled}
            name={name}
          />

          <div
            className={classnames(
              prettyCheckbox.state,
              prettyCheckbox["p-primary-o"]
            )}
          >
            <img className="image" src={blueCheck} />
            <label className={styles.text}>{text}</label>
          </div>
        </div>
        {this.state.showRadios && (
          <Field
            name={`skills[${eleId}].have`}
            component={RadioGroup}
            props={{
              submitting: this.props.submitting,
              category: this.props.category,
              id: eleId
            }}
            submitting={this.props.submitting}
            onChangeRadio={this.props.onChangeRadio}
            defaultValue={this.props.defaultValueRadio}
          />
        )}
      </div>
    );
  }
}

CheckboxRadio.propTypes = {
  onCheck: PropTypes.func.isRequired
};

export default CheckboxRadio;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/CheckboxRadio.js